import React from 'react';

export default () => {
	return (
		<div className="divider"></div>
	)
}



// WEBPACK FOOTER //
// ./buttons/components/divider/Divider.js